import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pulse",
  "use": "pulse-usage",
  "viewBox": "0 0 21 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 11\" id=\"pulse\"><path d=\"M19.314 4.114h-2.526c-.444 0-.858.22-1.11.584l-2.272 3.3-2.19-7.05a1.348 1.348 0 0 0-2.542-.09l-2.13 5.404-2.762-2.285a1.348 1.348 0 0 0-.862-.307H.898a.898.898 0 1 0 0 1.796h1.864l3.113 2.579A1.348 1.348 0 0 0 7.99 7.5l1.892-4.8 2.084 6.712a1.348 1.348 0 0 0 2.396.364l2.662-3.865h2.29a.898.898 0 1 0 0-1.797z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol